import { blue05, blue20opacity20 } from '../../../colors/blue';
import { gray20, gray10, gray35, gray40opacity10 } from '../../../colors/gray';
import { green02, green02opacity20 } from '../../../colors/green';
import { orange02, orange02opacity20 } from '../../../colors/orange';
import { red01, red02opacity20 } from '../../../colors/red';
import { yellow02, yellow02opacity20 } from '../../../colors/yellow';
import { rem } from '../../../utils/rem';
export var MuiChip = {
    styleOverrides: {
        root: {
            color: gray20,
            backgroundColor: gray40opacity10,
            '&[class*=Mui-focusVisible]': {
                outline: "".concat(rem(1), " solid ").concat(blue05),
            },
        },
        deleteIcon: {
            color: gray35,
        },
    },
    customOverrides: {
        colorNeutral: {
            color: gray10,
        },
        colorBlue: {
            backgroundColor: blue20opacity20,
            color: blue05,
        },
        colorGreen: {
            backgroundColor: green02opacity20,
            color: green02,
        },
        colorYellow: {
            backgroundColor: yellow02opacity20,
            color: yellow02,
        },
        colorOrange: {
            backgroundColor: orange02opacity20,
            color: orange02,
        },
        colorRed: {
            backgroundColor: red02opacity20,
            color: red01,
        },
    },
};
